import Vue from "vue";
import Vuex from "vuex";

import {
  VERIFICATION_REQUEST,
  VERIFICATION_SUCCESS,
  VERIFICATION_ERROR,
  VERIFICATION_METHOD
} from "@/store/types";

import applicant from "./applicant";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false,
    verification: null,
    error: null,
    verifyType: "",
    method: ""
  },
  mutations: {
    [VERIFICATION_REQUEST]: state => {
      state.isLoading = true;
    },
    [VERIFICATION_SUCCESS]: (state, { verification, verifyType }) => {
      state.isLoading = false;
      if (verification) state.verification = verification;
      if (verifyType) state.verifyType = verifyType;
    },
    [VERIFICATION_ERROR]: (state, error) => {
      state.isLoading = false;
      state.error = error;
    },
    [VERIFICATION_METHOD]: (state, method) => {
      state.method = method;
    }
  },
  getters: {
    getVerification: state => state.verification,
    getVerifyType: state => state.verifyType,
    isLoading: state => state.isLoading,
    getError: state => state.error,
    getMethod: state => state.method
  },
  actions: {},
  modules: {
    applicant
  }
});
